import { Plug } from '../../components/Plug/Plug';
import './ContactsPage.scss';

export const ContactsPage = () => {
  return (
    <section className="gallery">
      <Plug />
    </section>
  );
};